import React from 'react';
import { Form, Header, Loader, Responsive, Segment, Tab } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import EmployeesTable from './EmployeesTable';
import axios from 'axios';
import request from '../../util/request';
import moment from 'moment';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const employeeTabPositions = [
    { index: 0, employee: 'professor' },
    { index: 1, employee: 'assistant' },
    { index: 2, employee: 'demonstrator' },
    { index: 3, employee: 'laborant' },
    { index: 4, employee: 'associate' }
];

export default class Employees extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            positions: [],
            orgUnits: [],
            orgUnit: null,
            loading: true,
            loader: true,
            userButton: false,
            employeeName: 'professor',
            excelData: []

        };

        this.handleTabChange = this.handleTabChange.bind(this);
        this.getEmployees = this.getEmployees.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    componentDidMount() {
        localStorage.setItem('courseRoleType', '');
        if (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support') {
            this.setState({ loading: false, loader: false });
        }
        if (localStorage.getItem('orgUnit')) {
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit')) });
            this.getEmployees(this.state.employeeName);
        }

        if (localStorage.getItem('activeRole') !== 'AIDA' && localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') {
            this.getEmployees(this.state.employeeName);
        }

        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));

        if (localStorage.getItem('orgUnit')) {
            let orgUnit = localStorage.getItem('orgUnit');
            let activeRole = localStorage.getItem('activeRole');
            window.localStorage.clear();
            localStorage.setItem('orgUnit', orgUnit);
            localStorage.setItem('activeRole', activeRole);
        } else {
            let activeRole = localStorage.getItem('activeRole');
            window.localStorage.clear();
            localStorage.setItem('activeRole', activeRole);
        }


        axios.get('positions')
            .then(res => {
                const positions = res.data;
                this.setState({ positions, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch positions');
            });
        if (this.props.user) { this.setState({ userButton: true }); }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        localStorage.setItem('orgUnit', value);
        this.getEmployees(this.state.employeeName);
    }


    getEmployees(employeeName) {
        let obj = {};

        this.setState({ data: [], loader: true });
        // eslint-disable-next-line no-unused-expressions
        (localStorage.getItem('activeRole').substr(0, 8) === 'Student:') ?
            axios.get(`employees/info-for-students/by-key/${employeeName}`, { ...obj })
                .then(res => {
                    this.setState({ data: this.state.employeeName === employeeName ? res.data : this.state.data, loader: false });
                })
                .catch(err => {
                    console.log('Failed to fetch employees');
                })

            :

            axios.post((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja'))
                ? `employees/by-key/${employeeName}/${localStorage.getItem('orgUnit')}`
                : `employees/by-key/${employeeName}`, { ...obj })
                .then(res => {
                    this.setState({ data: res.data, loader: false });
                    const excelData = res.data.map(el => ([
                        { value: el.lastName },
                        { value: el.firstName },
                    ]));
                    this.setState({ excelData });
                })
                .catch(err => {
                    console.log('Failed to fetch employees');
                });
    }


    handleTabChange(e, { activeIndex }) {
        let employeeName = employeeTabPositions.find(el => el.index === activeIndex).employee;
        this.setState({ data: [], loader: true }, () => this.getEmployees(employeeName));
        this.setState({ employeeName });
    }

    render() {
        let panes = [];
        const { loading } = this.state;
        if (localStorage.getItem('activeRole').substr(0, 8) === 'Student:') {
            panes = [
                {
                    menuItem: { content: <FormattedMessage id="common.professors" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            loader={this.state.loader}
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="professor"
                            professor
                        /></Tab.Pane>)
                },
                {
                    menuItem: { content: <FormattedMessage id="common.assistants" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            loader={this.state.loader}
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="assistant"
                        /></Tab.Pane>)
                }

            ];
        } else {
            panes = [
                {
                    menuItem: { content: <FormattedMessage id="common.professors" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            loader={this.state.loader}
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="professor"
                            professor
                            courseRoleType={localStorage.setItem('courseRoleType', 'profesor')}
                        /></Tab.Pane>)
                },
                {
                    menuItem: { content: <FormattedMessage id="common.assistants" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            loader={this.state.loader}
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="assistant"
                            professor
                            courseRoleType={localStorage.setItem('courseRoleType', 'asistent')}
                        /></Tab.Pane>)
                },
                {
                    menuItem: { content: <FormattedMessage id="common.demonstrators" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="demonstrator"
                        /></Tab.Pane>)
                },
                {
                    menuItem: { content: <FormattedMessage id="common.laborants" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="laborant"
                        /></Tab.Pane>)
                },
                {
                    menuItem: { content: <FormattedMessage id="common.associates" /> },
                    render: () => (<Tab.Pane as={Responsive}>
                        <EmployeesTable
                            data={this.state.data}
                            excelData={this.state.excelData}
                            userButton={this.state.userButton}
                            employeeName="associate"
                        /></Tab.Pane>)
                },
            ];
        }

        return (
            <div>
                {this.props.user ? <Header as="h1"><FormattedMessage id="common.userAccounts" /> </Header>
                    : <Header as="h1"><FormattedMessage id="common.academicStaff" /> </Header>
                }
                <Segment.Group raised>
                    <Segment><h3><FormattedMessage id="common.academicStaffList" /></h3></Segment>
                    <Segment>
                        {(localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') &&
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.orgUnits}>
                                    <label><FormattedMessage id="common.organizationalUnit" /></label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={<FormattedMessage id="common.selectOrganizationalUnit" />}
                                        value={this.state.orgUnit}
                                        onChange={this.handleInputChange}
                                        name="orgUnit"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                {/*<Form.Field />*/}
                                <Form.Field />
                            </Form.Group>

                        </Form>
                        }
                        {(this.state.orgUnit || (localStorage.getItem('activeRole') !== 'AIDA' && localStorage.getItem('activeRole') !== 'Administrator' && localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja')) && <div>
                            { loading ?
                                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                : <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />}
                        </div>}

                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Employees/Employees.js